module.exports = __webpack_public_path__ + "img/gbyte.4e6c7c62.svg";